module.exports = __webpack_public_path__ + "static/media/Stop.8ee3801d.svg";